<!-- Slider main container -->
<div class="schedule-swiper">
  <!-- Additional required wrapper -->
  <div class="schedule-swiper-wrapper">
    <div class="swiper-section-title pt-4 pt-md-0">{{translationScope+'.titles.select_start_date_first' | transloco}}</div>
    <!-- Slides -->
    <div *ngFor="let group of scheduleDateGroups; let i = index">
      <div class="swiper-slide row" *ngIf="i + 1 === dateSlideIndex">
        <div class="col-4 px-1" *ngFor="let schedule of group; let s = index">
          <div
            class="schedule-date"
            [ngClass]="{ active: schedule.id === selectedScheduleId }"
            (click)="selectedScheduleDate(schedule)"
          >
            {{ schedule.startDate | date: 'dd.MM.yyyy' }}
          </div>
        </div>
        <ng-container *ngIf="scheduleDateGroups.length > 1">
          <div class="col-12 px-2 pb-4">
            <button (click)="showMoreSchedules()" class="btn btn-clear mt-2">
              <span class="text-uppercase">{{translationScope+".action_buttons.see_more_dates" | transloco}}</span>
              <div class="icon"><i class="fas fa-arrow-right"></i></div>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- <div class="swiper-pagination text-right" *ngIf="scheduleDateGroups.length > 1">
    <button (click)="previousDateGroup()">
      <i class="fas fa-chevron-left"></i>
    </button>
    {{ dateSlideIndex }} /{{ scheduleDateGroups.length }}
    <button (click)="nextDateGroup()"><i class="fas fa-chevron-right"></i></button>
  </div> -->
</div>

<div class="schedule-swiper mt-3" *ngIf="selectedScheduleId">
  <!-- <div class="schedule-swiper-wrapper timeslot-wrapper">
    <div class="swiper-section-title">{{ translationScope + '.titles.select_timeslot' | transloco }}</div>
    <div *ngFor="let group of scheduleTimeGroups; let i = index">
      <div class="swiper-slide row" *ngIf="i + 1 === timeSlideIndex">
        <div class="col-4 px-2" *ngFor="let schedule of group; let s = index">
          <div
            class="schedule-date"
            [ngClass]="{ active: schedule.id === selectedScheduleTimeId }"
            (click)="selectedScheduleTime(schedule)"
          >
            {{ schedule.startDate | date: 'HH:mm' }}
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="schedule-swiper-wrapper timeslot-wrapper" *ngIf="selectedSchedule">
    <div class="swiper-section-title">{{ translationScope + '.titles.selected_timeslot' | transloco }}</div>
    <div class="swiper-slide row">
      <div class="col-4 px-2">
        <div class="schedule-date active">
          {{ selectedSchedule.startDate | date: 'HH:mm' }}
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="swiper-pagination text-right" *ngIf="scheduleTimeGroups.length > 1">
    <button (click)="previousTimeGroup()">
      <i class="fas fa-chevron-left"></i>
    </button>
    {{ timeSlideIndex }} /{{ scheduleTimeGroups.length }}
    <button (click)="nextTimeGroup()"><i class="fas fa-chevron-right"></i></button>
  </div> -->
</div>
